import React, { useRef, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import CustomSnackbar from '../Optics/Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import { WriteHouseEntranceCoordinate } from '../Optics/WriteData/WriteHouseEntrancesCoordinates';

const ModalUpdatingHouse = ({ open, onClose,houseId, street, houseNumber, entrances, coordinates, searchAddress }) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const mapRef = useRef();
  const [markers, setMarkers] = useState([]);
  const [mapType, setMapType] = useState('osm');

  const toggleMap = () => {
    setMapType(prev => (prev === 'osm' ? 'esri' : 'osm'));
  };

  useEffect(() => {
    if (mapRef.current && coordinates.length > 0) {
      const map = mapRef.current;
      map.setView([coordinates[0].latitude, coordinates[0].longitude], 18);
    }
  }, [coordinates]);

  const addMarker = (e) => {
    if (markers.length < entrances) {
      const newMarker = {
        position: e.latlng,
        entrance: markers.length + 1,
      };
      setMarkers([...markers, newMarker]);
    } else {
      showSnackbar(`Количество маркеров не может превышать количество ${entrances} подъездов!`, 'snackbarWarning');
    }
  };

  const removeMarker = (idx) => {
    const newMarkers = markers.filter((_, index) => index !== idx);
    setMarkers(newMarkers);
  };

   const handleSubmit = async () => {
    WriteHouseEntranceCoordinate(markers, showSnackbar, entrances, houseId, searchAddress);
   };

  const MapEvents = () => {
    useMapEvents({
      click(e) {
        addMarker(e);
      },
    });
    return null;
  };

  const handleClose = () => {
    onClose(); 
    setMarkers([]); 
  };


 
   

  return (
    <Dialog open={open} className="modalStyleUpTer">
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Актуализация дома</label>
        <hr className='horizontalLineModalUpTer' />
        <div>
          <label style={{color: "orange"}}>Адрес: <span style={{color: "#c5c5c5"}}> ул. {street}, дом: {houseNumber}</span></label>
          <br/>
          <label style={{color: "orange"}}>Подъездов: <span style={{color: "#c5c5c5"}}>{entrances}</span></label>
          <br/>
          <button className='buttonIsHideModalUpTer' onClick={handleSubmit}>Отправить на сервер</button>
          <button
            onClick={toggleMap}
            className='buttonIsHideModalUpTer'
            style={{
              position: 'absolute', // или 'fixed', если хочешь, чтобы кнопка была фиксированной на экране, даже при прокрутке
              top: '10px',
              right: '30px',
              zIndex: 1000,
            
            }}
          >
            {mapType === 'osm' ? 'Карта Esri' : 'Карта OSM'}
          </button>
        
          <div style={{ height: '400px', width: '100%', borderRadius: '10px', marginTop: '10px' }}>

            <MapContainer
              center={coordinates.length > 0 ? [coordinates[0].latitude, coordinates[0].longitude] : [0, 0]}
              zoom={18}
              minZoom={6}
              style={{ height: '100%', width: '100%', borderRadius: "10px"}}
              ref={mapRef}
            >
                {mapType === 'osm' ? (
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
        ) : (
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            attribution='Tiles © Esri'
            maxZoom={19}
          />
        )}
             
              <MapEvents />
              {markers.map((marker, idx) => (
                <Marker
                   key={idx}
                   position={marker.position}
                   icon={L.icon({ iconUrl: './entrance.png', iconSize: [30, 30], iconAnchor: [15, 15] })}
                >
                  <Popup  className="custom-popupUpTer">
                  <label style={{color: "#424242"}}> Подъезд: <span style={{color: "black"}}> {marker.entrance}</span></label>
                  
                    <br />
                    <button  className="popupButtonDeleteUpTer" onClick={(e) => { e.stopPropagation(); removeMarker(idx); }}>Удалить маркер</button>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
          <hr className='horizontalLineModalUpTer' />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} class='buttonIsHideModalUpTer'>
          Закрыть
        </Button>
      </DialogActions>
        {/* Snackbar */}
        <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? 'orange' : 'orange'
            }
          }}
        />
    </Dialog>
  );
};

export default ModalUpdatingHouse;
